var modal = {
    defaults: {
        hide_close: false,
        message_is_element: false,
        button: true,
        button_text: "OK",
        button_template:
            "<button class='btn btn--size--default btn--color--resting--green btn--color--hover--green' onclick='event.preventDefault();modal.close();'>Ok</button>",
        message: "This is a modal",
        additional_classes: "",
        image: {
            url: null,
            url_2x: null,
            width: null,
            height: null,
            has_dark_background: false
        },
        onClose: null,
    },
    current_args: null,
    borrowed_element_parent: null,
    last_target: null,
    element: {
        parent_js: null,
        parent: null,
        close: null,
        content: {
            image: null,
            text: null
        },
        footer: null,
        background: null
    },
    events: {
        ready: new Event('modal-ready'),
        open: new Event('modal-open'),
        close: new Event('modal-close'),
    },
    init: function () {
        modal.assign();
        modal.add_handlers();
        modal.close();
        document.dispatchEvent(modal.events.ready);
        window.modal = modal;
    },
    assign: () => {
        modal.element.parent_js = document.getElementById("modal");
        modal.element.parent = document.querySelector(".modal");
        modal.element.close = modal.element.parent.querySelector(".modal__close");
        modal.element.content.image = modal.element.parent.querySelector(".modal__content__image");
        modal.element.content.text = modal.element.parent.querySelector(".modal__content__text");
        modal.element.footer = modal.element.parent.querySelector(".modal__footer");
        modal.element.background = modal.element.parent.querySelector(".modal__background");
    },
    add_handlers: () => {
        modal.element.close.addEventListener("click", () => modal.close());
    },
    open: () => {
        if (modal.element.parent.classList.contains("active")) return;
        modal.element.parent.classList.add("active");
        document.body.dataset.modal = "active";
        document.dispatchEvent(modal.events.open);
        modal.take_focus();
    },
    close: () => {
        if (!modal.element.parent.classList.contains("active")) return;
        modal.element.parent.classList.add("leaving");
        document.body.dataset.modal = "";
        document.dispatchEvent(modal.events.close);

        setTimeout(() => modal.do_closed(), 250);
    },
    do_closed: () => {
        modal.element.parent.classList.remove("active", "leaving");

        if (modal.current_args?.message_is_element) {
            modal.return_element(modal.current_args);
        }

        if (typeof modal.current_args?.onClose === "function") {
            modal.current_args.onClose();
        }

        modal.current_args = null;
        modal.remove_additional_classes();
        modal.lose_focus();
    },
    set: (args, last_target = null) => {
        console.log(args);

        var new_defaults = {
            hide_close: args.hide_close ?? modal.defaults.hide_close,
            message_is_element: args.message_is_element ?? modal.defaults.message_is_element,
            button: args.button ?? modal.defaults.button,
            button_text: args.button_text ?? modal.defaults.button_text,
            button_template: args.button_template ?? modal.defaults.button_template,
            message: args.message ?? modal.defaults.message,
            image: args.image ?? modal.defaults.image,
            additional_classes: args.additional_classes ?? modal.defaults.additional_classes,
            onClose: args.onClose ?? modal.defaults.onClose
        };

        modal.current_args = new_defaults;

        modal.set_additional_classes(new_defaults);
        modal.set_buttons(new_defaults);
        modal.set_message(new_defaults);
        modal.set_close(new_defaults);
        modal.set_image(new_defaults);
        modal.open();

        if (last_target !== null) {
            modal.last_target = last_target;
        }
    },
    set_image: (args) => {
        if (!args.image.url) {
            modal.clear_image();
        } else {
            modal.replace_image(args);
        }
    },
    set_additional_classes: (args) => {
        modal.element.parent.setAttribute("data-additional-classes", args.additional_classes);
    },
    remove_additional_classes: () => {
        console.log("removing additional classes");
        modal.element.parent.setAttribute("data-additional-classes", "");
    },
    clear_image: () => {
        modal.element.parent.classList.remove("modal--has-image", "modal--has-dark-image");
        modal.element.content.image.innerHTML = "";
    },
    replace_image: (args) => {
        modal.clear_image();
        modal.element.parent.classList.add("modal--has-image");
        modal.element.content.image.innerHTML = modal.build_image(args);
        if (args.image.has_dark_background === "true") {
            modal.element.parent.classList.add("modal--has-dark-image");
        }
    },
    build_image: (args) => {
        return `<picture><img src="${args.image.url}" width="${args.image.width}" height="${args.image.height}" loading="lazy"/></picture>`;
    },
    set_message: (args) => {
        if (args.message_is_element) {
            modal.borrow_element(args);
        } else {
            modal.element.content.text.innerHTML = args.message;
        }
    },
    borrow_element: (args) => {
        let borrowed_elem = document.querySelector(args.message);
        modal.borrowed_element_parent = borrowed_elem.parentElement;
        modal.element.content.text.innerHTML = "";
        modal.element.content.text.appendChild(borrowed_elem);
    },
    return_element: (args) => {
        let current_borrowed_element = document.querySelector(args.message);
        modal.borrowed_element_parent.appendChild(current_borrowed_element);
        modal.borrowed_element_parent = null;
    },
    set_buttons: (args) => {
        if (!args.button) {
            modal.clear_buttons();
        } else {
            modal.replace_buttons(args.button_template);
        }

        let button = modal.element.footer.querySelector("button");
        if (button) {
            button.textContent = args.button_text;
        }
    },
    clear_buttons: () => {
        modal.element.footer.innerHTML = "";
    },
    replace_buttons: (new_buttons) => {
        if (!new_buttons) return;
        modal.clear_buttons();
        modal.element.footer.innerHTML = new_buttons;
    },
    set_close: (args) => {
        modal.element.close.style.display = args.hide_close ? "none" : "block";
    },
    show_close: () => {
        modal.set_close({ hide_close: false });
    },
    lose_focus: () => {
        modal.element.parent_js.setAttribute("aria-hidden", "true");
        document.querySelectorAll("main, footer, header").forEach(el => el.removeAttribute("tabindex"));
        modal.element.parent.querySelectorAll("a, button").forEach(el => el.setAttribute("tabindex", "-1"));
        if (modal.last_target !== null) {
            modal.last_target.focus();
            modal.last_target = null;
        }
    },
    take_focus: () => {
        modal.element.parent_js.setAttribute("aria-hidden", "false");
        modal.element.close.focus();
        document.querySelectorAll("main, footer, header").forEach(el => el.setAttribute("tabindex", "-1"));
        modal.element.parent.querySelectorAll("a, button").forEach(el => el.setAttribute("tabindex", "0"));
    },
};

modal.init();

export { modal };